export enum SubscriptionStateEnum {

  WAITING = 'WAITING',
  MISSING = 'MISSING',
  PURCHASED = 'PURCHASED'

}
